import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";
import { Props } from "./LayoutQuestionPage";

export const Box = styled.div<Props>`
  //  @media ${device.mobile} {
  //   height: 100%; //calc(100vh - 20px);
  // } 
  @media ${device.mobile} {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  @media ${device.desktop} {
    display: flex;
    justify-content: flex-start;
    height: 100%;
  }
`;
